window.Decors = function () {
    var el = this;
    var isMoving = false;
    var isResizing = false;
    var isRotating = false;
    var elsList = {};
    var selectedItems = {};
    var copyItem = false;
    var copyItemInfo = false;

    function set($element) {
        var filename = $element.attr('data-filename');

        if (!selectedItems.hasOwnProperty(filename)) {
            $element.addClass('active');
            selectedItems[filename] = {
                company_id: $element.attr('data-company'),
                id: $element.attr('data-id'),
                filename: $element.attr('data-filename'),
            }
        } else {
            $element.removeClass('active');
            delete selectedItems[filename];
        }
    }

    function load() {
        var i, item;
        for(i in selectedItems) {
            item = selectedItems[i];
            el.add(item.company_id, item.id, item.filename);
        }

        el.workarea.render();
        el.preview.update();

        el.dialog.hide('decors');
    }

    el.data = {};

    el.show = function () {
        var templateData = [];
        for (var i in el.data) {
            var grid = $.extend(true, {}, el.data[i]);
            grid['id'] = i;
            var templateThemes = [];
            for (var j in grid.themes) {
                var theme = grid.themes[j];
                var templateImages = [];

                for (var k in theme.images) {
                    var image = theme.images[k];
                    templateImages.push(image);
                }

                theme.images = templateImages;
                templateThemes.push(theme);
            }
            grid.themes = templateThemes;
            templateData.push(grid);
        }
        if (templateData.length > 0 ){
            templateData[0].is_active = true;
        }

        console.log(templateData)

        el.dialog.show('decors', {theme_groups: templateData});
    };

    el.selectDecor = function (gid, id) {
        var data = {
            company_id: el.data[gid].themes[id].company_id,
            theme_id: id,
            images: []
        };

        var i;
        var images = el.data[gid].themes[id].images;
        for (i in images) {
            if (images.hasOwnProperty(i)) {
                data.images.push({filename: el.data[gid].themes[id].images[i]});
            }
        }

        selectedItems = {};

        $('#decor-content-1').addClass('hide');
        $('#decor-content-2').removeClass('hide');
        var html = window.Mustache.render($('#decor-images-template').html(), data);
        $('#decor-content-2 .modal-body').html(html);
    };

    el.add = function(companyId, groupId, name) {
        var url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/decors/' + companyId + '/' + groupId + '/workimages/' + name;
        var image = new Image();

        image.onload = function () {
            var currentData = el._parent.workData.workareas[el.selectWorkareaId].format;
            if (!currentData.hasOwnProperty('decors')) {
                currentData.decors = {};
            }

            var keys = Object.keys(currentData.decors);
            var number = 1;
            if (keys.length > 0) {
                number = parseInt(keys[keys.length - 1]) + 1;
            }

            currentData.decors[number] = {
                x: 0,
                y: 0,
                width: this.width,
                height: this.height,
                transform: '',
                name: name,
                group_id: groupId,
                company_id: companyId
            };

            el.layer.add(el.selectWorkareaId, 'decors', number);

            el.history.add();

            el.workarea.render();
            el.preview.update();
        };

        image.src = url;
    };

    el.copy = function () {
        var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
        copyItem = reversal.decors[el.selectId];

        copyItemInfo = {
            workarea_width : reversal.width,
            workarea_height : reversal.height,
            workarea_id : el.selectWorkareaId,
        }
    };

    el.paste = function () {
        var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;

        var keys = Object.keys(reversal.decors);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        copyItem = copyItem || reversal.decors[el.selectId];

        if (typeof(copyItem) === 'undefined') {
            return;
        }

        var decor = $.extend(true, {}, copyItem);

        if (copyItemInfo.workarea_height == reversal.height && copyItemInfo.workarea_width == reversal.width 
            && copyItemInfo.workarea_id != el.selectWorkareaId ) {
            decor.x = copyItem.x;
            decor.y = copyItem.y;
        } else {
            decor.x = parseInt((reversal.width - decor.width) / 2);
            decor.y = parseInt((reversal.height - decor.height) / 2);
        }

        reversal.decors[number] = decor;
        el.layer.add(el.selectWorkareaId, 'decors', number);

        copyItem = false;

        el.workarea.render();
        el.preview.update();

        el.history.add();
    };

    el.remove = function () {
        var element = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);
        element.parentNode.removeChild(element);
        delete el._parent.workData.workareas[el.selectWorkareaId].format.decors[el._parent.selectId];

        el.layer.remove(el.selectWorkareaId, 'decors', el.selectId);

        el.selection.hide();

        el.history.add();
    };

    /**
     * @param {Event} event
     */
    el.beginRotate = function (event) {
        event.preventDefault();
        isRotating = true;
        el._parent.isTransforming = true;

        var element = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);
        var pos = el.transform.getPosition(element);

        elsList = {
            element: element,
            coords: {
                centerX: pos.x + (pos.width / 2),
                centerY: pos.y + (pos.height / 2)
            }
        };
    };

    el.rotate = function (event) {
        if (isRotating) {
            var element = elsList.element;
            var pos = elsList.coords;

            var workAreaScale = el.workarea.workAreaScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = el.svgRoot.getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle, elsList.coords.centerX, elsList.coords.centerY);

            // set new transform property for el._parent.workData;
            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var rotate = el.transform.getRotate(element);
            reversal.decors[el.selectId].rotate_angle = rotate.angle;
            reversal.decors[el.selectId].rotate_x = elsList.coords.centerX;
            reversal.decors[el.selectId].rotate_y = elsList.coords.centerY;

            el.selection.update(element);
        }
    };

    el.endRotate = function () {
        if (isRotating) {
            isRotating = false;
            el.history.add();
        }
    };

    el.beginMove = function () {
        isMoving = true;
        el._parent.isTransforming = true;
        var element = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            coord: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0,
            parent: false
        };
    };

    el.move = function (event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var element = elsList.element;

            var elementTransform = el.transform.deleteRotate(element);

            var pos = {
                x: parseInt(elsList.coord.x + elsList.x),
                y: parseInt(elsList.coord.y + elsList.y)
            };

            el.transform.setPosition(element, pos.x, pos.y);

            // set rotate of element
            if (elementTransform.angle !== 0) {
                el.transform.setRotate(element, elementTransform.angle);
            }

            // set new position for el._parent.workData
            reversal.decors[el.selectId].x = pos.x;
            reversal.decors[el.selectId].y = pos.y;

            var rotate = el.transform.getRotate(element);
            reversal.decors[el.selectId].rotate_angle = rotate.angle;
            reversal.decors[el.selectId].rotate_x = rotate.x;
            reversal.decors[el.selectId].rotate_y = rotate.y;

            el.selection.update(element);
        }
    };

    el.keyMovement = function (keyMovement) {
        if (isMoving) {
            var pos = {
                x: parseInt(elsList.coord.x + keyMovement.X),
                y: parseInt(elsList.coord.y + keyMovement.Y)
            };

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var element = elsList.element;

            var elementTransform = el.transform.deleteRotate(element);

            el.transform.setPosition(element, pos.x, pos.y);

            // set rotate of element
            if (elementTransform.angle !== 0) {
                el.transform.setRotate(element, elementTransform.angle);
            }

            // set new position for el._parent.workData
            reversal.decors[el.selectId].x = pos.x;
            reversal.decors[el.selectId].y = pos.y;

            var rotate = el.transform.getRotate(element);
            reversal.decors[el.selectId].rotate_angle = rotate.angle;
            reversal.decors[el.selectId].rotate_x = rotate.x;
            reversal.decors[el.selectId].rotate_y = rotate.y;

            el.selection.update(element);
        }
    };

    el.endMove = function () {
        if (isMoving) {
            isMoving = false;
            el.history.add();
        }
    };

    /**
     * @param {Event} event
     * @param {string} type
     */
    el.beginResize = function (event, type) {
        event.preventDefault();
        isResizing = true;
        el._parent.isTransforming = true;
        var element = el.svgRoot.getElementById('decors-item-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            coords: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            type: type,
            x: 0,
            y: 0
        };
    };

    el.resize = function (event) {
        if (isResizing) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY - elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var item = el._parent.workData.workareas[el.selectWorkareaId].format.decors[el._parent.selectId];
            var minSize = 50;

            var coords = $.extend(true, {}, elsList.coords);

            switch (elsList.type) {
                case 'width':
                    coords.width = parseInt(elsList.coords.width + elsList.x);
                    break;
                case 'height':
                    coords.height = parseInt(elsList.coords.height + elsList.y);
                    break;
                case 'x':
                    coords.x = parseInt(elsList.coords.x + elsList.x);
                    coords.width = parseInt(elsList.coords.width - elsList.x);
                    break;
                case 'y':
                    coords.y = parseInt(elsList.coords.y + elsList.y);
                    coords.height = parseInt(elsList.coords.height - elsList.y);
                    break;
                case 'nw':
                    coords.x = parseInt(elsList.coords.x + elsList.x);
                    coords.width = parseInt(elsList.coords.width - elsList.x);
                    coords.y = parseInt(elsList.coords.y + elsList.y);
                    coords.height = parseInt(elsList.coords.height - elsList.y);
                    break;
                case 'ne':
                    coords.width = parseInt(elsList.coords.width + elsList.x);
                    coords.y = parseInt(elsList.coords.y + elsList.y);
                    coords.height = parseInt(elsList.coords.height - elsList.y);
                    break;
                case 'se':
                    coords.width = parseInt(elsList.coords.width + elsList.x);
                    coords.height = parseInt(elsList.coords.height + elsList.y);
                    break;
                case 'sw':
                    coords.x = parseInt(elsList.coords.x + elsList.x);
                    coords.width = parseInt(elsList.coords.width - elsList.x);
                    coords.height = parseInt(elsList.coords.height + elsList.y);
                    break;
            }

            // check size cell
            if (
                    coords.width < minSize
                    || coords.height < minSize
                    //   || coords[0].width > el.workData.width
                    //   || coords[0].height > el.workData.height
                    ) {
                return false;
            }

            // update position for viewer
            elsList.element.setAttribute('x', coords.x);
            elsList.element.setAttribute('y', coords.y);
            elsList.element.setAttribute('width', coords.width);
            elsList.element.setAttribute('height', coords.height);

            // update position for el._parent.workData
            item.x = coords.x;
            item.y = coords.y;
            item.width = coords.width;
            item.height = coords.height;

            el.selection.update(elsList.element);
        }
    };

    el.endResize = function () {
        if (isResizing) {
            isResizing = false;
            el.history.add();
        }
    };

    $('.js-decors-show').on('click', function () {
        el.show();
    });

    $(document).on('click', '.js-decor-show', function () {
        el.selectDecor($(this).attr('data-group'), $(this).attr('data-id'));
    });

    $(document).on('click', '.js-decor-back', function () {
        $('#decor-content-2').addClass('hide');
        $('#decor-content-1').removeClass('hide');
    });

    $(document).on('click', '.js-decor-set', function () {
        set($(this));
    });

    $(document).on('click', '.js-decor-load', function () {
        load()
    });
};
